var React = require('react');

function ArticleFb (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.9 0.5H2.1C1.21634 0.5 0.5 1.21634 0.5 2.1V27.9C0.5 28.7837 1.21634 29.5 2.1 29.5H16V18.285H12.225V13.895H16V10.665C16 6.92 18.29 4.88 21.63 4.88C22.7555 4.87755 23.8804 4.93429 25 5.05V8.965H22.7C20.88 8.965 20.525 9.825 20.525 11.095V13.89H24.875L24.31 18.28H20.5V29.5H27.9C28.7837 29.5 29.5 28.7837 29.5 27.9V2.1C29.5 1.21634 28.7837 0.5 27.9 0.5Z","fill":"#FF6600"}));
}

ArticleFb.defaultProps = {"width":"20","height":"20","viewBox":"0 0 30 30","fill":"none"};

module.exports = ArticleFb;

ArticleFb.default = ArticleFb;
